
var initialState =
{
    name: "",
    city: "",
    postalNumber: "",
    address: "",
    email: "",
    phone: "",
    country: "fi",
    consent: false,
    notes: "",
    attachments: []

}
const contactDetails = (state = initialState, action) => {
    switch (action.type) {
        case "CUSTOMER_CONSENT_UPDATED":
            return Object.assign({}, state, {
                consent: action.consent
            })
        case "UPDATE_CONTACT_DETAILS":
            return { ...state, ...action.contactDetails };
        default:
            return state;
    }
}

export default contactDetails
